import { render, staticRenderFns } from "./ProductAttribute.vue?vue&type=template&id=76f26046&scoped=true"
import script from "./ProductAttribute.vue?vue&type=script&lang=js"
export * from "./ProductAttribute.vue?vue&type=script&lang=js"
import style0 from "./ProductAttribute.vue?vue&type=style&index=0&id=76f26046&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f26046",
  null
  
)

export default component.exports